<template>
    <v-container fluid class="pt-0">
        <v-row>
            <v-col cols="12" class="pa-0">
                <v-sheet class="" color="#008dd4" height="10vh"></v-sheet>
            </v-col>

            <v-col cols="12" xl="3" lg="3" md="4" style="position:relative; top: -60px">
                <v-card>
                    <v-list two-line subheader>
                        <v-list-item>
                            <v-list-item-avatar>
                                <v-icon color="#008dd4" x-large>mdi-account-star</v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title><strong>Registro total Administrativos</strong></v-list-item-title>
                                <v-list-item-subtitle class="text-h4">{{ items.length }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>

                <v-btn block class="mt-3" color="success" @click="incriptions_per_day()">Inscritos por día</v-btn>
            </v-col>

            <v-col cols="12" xl="9" lg="9" md="8" style="position:relative; top: -60px">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        :loading="loading"
                        :footer-props="footer_props"
                        :loading-text="loading_text"
                        :no-data-text="no_data_text"
                        :no-results-text="no_result_text"
                        :search="search"
                    >
                        <template v-slot:top>
                            <v-container class="py-0">
                                <v-row justify="center" align="center">
                                    <v-col cols="12" lg="6">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn fab color="#008dd4" v-bind="attrs" v-on="on" @click="create_dialog = true" dark>
                                                    <v-icon>mdi-account-plus</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Nuevo registro</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="12" lg="6">
                                        <v-text-field
                                            v-model="search"
                                            clearable
                                            dense
                                            outlined
                                            hide-details
                                            label="Buscar"
                                            append-icon="mdi-magnify"
                                            color="#818181"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-menu offset-y>
                                <template v-slot:activator="{ attrs, on }">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                        <v-icon>mdi-menu</v-icon>
                                    </v-btn>
                                </template>
                                
                                <v-list>
                                    <v-list-item @click="get_link(item.id)">
                                        <v-list-item-content>
                                            <v-list-item-title>Mostrar enlace</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </template>
                        </v-data-table>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="create_dialog" max-width="500" persistent>
            <v-card :loading="create_loading" :disabled="create_loading">
                <v-card-title>Nuevo usuario Administrativo</v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4">
                    <v-form ref="register_form">
                        <v-text-field v-model="user.names" :rules="[rules.required]" outlined label="Nombre(s)"></v-text-field>
                        <v-text-field v-model="user.paternal_surname" :rules="[rules.required]" outlined label="Apellido paterno"></v-text-field>
                        <v-text-field v-model="user.maternal_surname" :rules="[rules.required]" outlined label="Apellido materno"></v-text-field>
                        <v-text-field v-model="user.phone" :rules="[rules.required]" outlined label="Teléfono"></v-text-field>
                        <v-text-field v-model="user.email" :rules="[rules.required, rules.email]" outlined label="Correo electrónico"></v-text-field>
                        <v-text-field type="password" v-model="user.password" :rules="[rules.required]" outlined label="Contraseña"></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#008dd4" dark :loading="create_loading" @click="register()">registrar</v-btn>
                    <v-btn text @click="() => { $refs.register_form.reset(); create_dialog = false }">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="show_link_dialog" max-width="500">
            <v-card v-if="link">
                <v-card-title>Enlace</v-card-title>
                <v-alert prominent type="info">
                    <v-row align="center">
                        <v-col class="grow">
                            {{ link }}
                        </v-col>
                        <v-col class="shrink">
                            <v-btn icon @click="copy()">
                                <v-icon>mdi-content-copy</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-alert>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="show_link_dialog = !show_link_dialog">cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="inscriptions_per_day_dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar flat color="#008dd4" dark>
                    <v-btn icon @click="inscriptions_per_day_dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Inscritos por día</v-toolbar-title>
                </v-toolbar>

                <v-card-text class="px-0">
                    <v-container class="pt-0" fluid>
                        <v-row class="pa-0" justify="center" align="center">
                            <v-col cols="12" class="pa-0">
                                <v-sheet class="" color="#008dd4" height="10vh"></v-sheet>
                            </v-col>

                            <v-col cols="10" class="px-10" style="position:relative; margin-top: -60px">
                                <v-card>
                                    <v-card-text>
                                        <v-data-table
                                            :items="inscriptions"
                                            :headers="headers_inscriptions"
                                            :loading="loading_inscriptions"
                                            :search="search_inscriptions"
                                        >
                                            <template v-slot:top>
                                                <v-row>
                                                    <v-col cols="12" xl="4" lg="4" md="6">
                                                        <v-menu
                                                            ref="date"
                                                            v-model="date_picker"
                                                            :close-on-content-click="false"
                                                            :return-value.sync="selected_date"
                                                            transition="scale-transition"
                                                            offset-y
                                                            min-width="auto"
                                                        >
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-text-field v-model="selected_date"  outlined label="Fecha" readonly v-bind="attrs" v-on="on"></v-text-field>
                                                            </template>
                                                            <v-date-picker v-model="selected_date" range no-title scrollable>
                                                                <v-spacer></v-spacer>
                                                                <v-btn
                                                                    text
                                                                    color="primary"
                                                                    @click="$refs.date.save(selected_date)"
                                                                >
                                                                    OK
                                                                </v-btn>
                                                            </v-date-picker>
                                                        </v-menu>
                                                    </v-col>
                                                    <v-col cols="12" xl="8" lg="8" md="6">
                                                        <v-text-field v-model="search_inscriptions" outlined label="Busqueda..." append-icon="mdi-magnify"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" >
                                                        <v-textarea
                                                            rows="3" v-model="whatsapp_message" outlined name="input-7-4" label="Mensaje de ayuda" 
                                                        ></v-textarea>
                                                    </v-col>
                                                </v-row>
                                            </template>
                                            <template v-slot:item.referred.phone="{ item }">
                                                <v-btn color="success" class="ma-2 white--text" @click="whatsapp(item)">
                                                    {{item.referred.phone}}
                                                    <v-icon right dark>
                                                        mdi-whatsapp
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <template v-slot:item.payment="{ item }">
                                                <v-chip :color="item.applied ? 'success' : 'error'">
                                                    {{ item.applied ? 'Pagado' : 'Sin pago' }}
                                                </v-chip>
                                            </template>
                                        </v-data-table>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>

    </v-container>
</template>
<script>

import iziToast from 'izitoast'

export default {
    data: () => ({
        whatsapp_message: 'Hola @nombre somos de instituto nuemann vemos que no haz completado tu proceso de inscripcion del curso @curso hay algo en lo que podamos ayudarte?',

        //dialogs
        create_dialog:false,
        show_link_dialog:false,
        inscriptions_per_day_dialog:false,
        create_loading:false,

        rules:{
            required: v => !!v || 'El campo es requerido',
            email: v => /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/.test(v) || 'El Correo electrónico ingresado no es válido',
        },

        user:{
            name:"",
            names:"",
            paternal_surname:"",
            maternal_surname:"",
            phone:"",
            email:"",
            password:"",
            password_confirmation:"",
        },

        //register link
        link:"",
        copied:false,


        items:[],
        //data table props administratives
        color:"#818181",
        search:"",
        loading:"#008dd4",
        loading_text:"Cargando...",
        no_data_text:"Sin elementos registrados",
        no_result_text:"Sin coincidencias",
        headers:[
            { text:'ID', value:'id' },
            { text:'Nombre(s)', value:'fullname' },
            { text:'Teléfono', value:'phone'},
            { text:'Correo', value:'email' },
            { text: 'Acciones', value:'actions', sorteable:false}
        ],
        footer_props:{
            itemsPerPageText:"Filas por página",
            showCurrentPage:true,
            itemsPerPageAllText:"Todo",
            showFirstLastPage:true,
        },

        //data table props inscriptions per day dialog
        inscriptions:[],
        date_picker:false,
        selected_date:"",
        search_inscriptions:"",
        loading_inscriptions:false,
        headers_inscriptions:[
            { text:'Fecha', value:'date_time' },
            { text:'Curso', value:'referred.student_course.course.name' },
            { text:'Estudiante', value:'referred.fullname' },
            { text:'Teléfono', value:'referred.phone' },
            { text:'Administrativo', value:'referrer.names'},
            { text:'Pagos', value:'payment' }
        ],
    }),

    mounted(){
        this.get_data()
    },

    watch:{
        selected_date:function()
        {
            this.incriptions_per_day()
        }
    },

    methods:{
        whatsapp:function(item)
        {
            var msg = this.whatsapp_message.replace('@nombre', item.referred.names).replace('@curso', item.referred.student_course.course.name)
            var phone = item.referred.phone
            if(phone.startsWith('+52'))
                phone=phone.substring(3)
            if(phone.startsWith('52'))
                phone=phone.substring(2)
            if(phone.startsWith('044'))
                phone=phone.substring(3)
            window.open('https://wa.me/52'+phone+'?text='+msg)
        },
        get_data:function()
        {
            this.loading = this.color
            axios.get('/administratives', { params:{ ajax:true } }).then(response => {
                this.items = response.data.items
            })
            this.loading = false
        },

        register:function()
        {
            if(this.$refs.register_form.validate()){
                this.create_loading = true

                this.user.name = this.user.email
                this.user.password_confirmation = this.user.password

                axios.post('/administratives', this.user).then(() => {

                    this.create_dialog = this.create_loading = false
                    this.$refs.register_form.reset()
                    
                    iziToast.success({
                            title:"Correcto",
                            position:'topRight',
                            message: "Usuario administrativo registrado correctamente"
                        })
                    
                    this.get_data()

                }).catch(error => {
                    this.create_loading = false
                    if(error.response.data.errors){
                        for(let prop in error.response.data.errors){
                            for(let message of error.response.data.errors[prop]){
                                iziToast.error({
                                    title:"Error",
                                    position:'topRight',
                                    message: message
                                })
                            }
                        }
                    }else{
                        iziToast.error({
                            title:"Error",
                            position:'topRight',
                            message: "Ha ocurrido un error en la comunicación con el servidor, intente más tarde"
                        })
                    }
                })
            }
        },

        get_link:function(id)
        {
            axios.get('/administratives/link/'+id, { params:{ ajax:true } }).then(response => {
                this.link = response.data.item
                this.show_link_dialog = true
            })
        },

        copy: async function()
        {
            await navigator.clipboard.writeText(this.link);
            iziToast.success({
                title:"Correcto",
                position:'topRight',
                message: "Enlace copiado correctamente"
            })
        },

        incriptions_per_day:function()
        {
            this.loading_inscriptions = true
            axios.get('/administratives/inscriptions_per_day/'+this.selected_date, { params:{ ajax:true } }).then(response => {
                this.inscriptions = response.data.items
                this.loading_inscriptions = false
                this.inscriptions_per_day_dialog = true
            })
        }
    }
}
</script>